module.exports = __webpack_public_path__ + "img/public/SiteIcons/rulesIcon.svg?7c73f7ba";